import { Box } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import ContainedButton from "../../../../../components/buttons/ContainedButton";
import { EmptyState } from "../../../../../components/common/EmptyState";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import {
  emptyStateIcons,
  icons,
} from "../../../../stack/environment/icons/iconExport";
const AIIntegrationsEmptyState = ({ onClick }) => {
  const colors = useColors();

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "48px 24px",
      gap: "32px",
      minHeight: "200px",
    },
    iconWrapper: {
      width: "48px",
      height: "48px",
      borderRadius: "12px",
      backgroundColor: colors.grey_100,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "8px",
    },
    icon: {
      fontSize: "24px",
    },
    title: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "22px",
      color: colors.grey_900,
      textAlign: "center",
    },
    description: {
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "20px",
      color: colors.grey_600,
      textAlign: "center",
      maxWidth: "320px",
    },
  };

  return (
    <Box sx={styles.container}>
      <EmptyState
        icon={emptyStateIcons.EmptyAIIntegrationsIcon}
        title="No AI integrations connected"
        description="Connect to start monitoring usage and security risks"
        smallText={true}
      />

      <ContainedButton
        onClick={onClick}
        color="primary"
        size="small"
        endIcon={
          <SvgToIcon IconLogo={icons.NewTabIcon} width="20px" height="20px" />
        }
      >
        Connect AI Integrations
      </ContainedButton>
    </Box>
  );
};

export default AIIntegrationsEmptyState;
